app.filter('selectedProductsOnly', ['Availability', function(Availability) {
	return function(items) {
		var filtered = [];
		angular.forEach(items, function(items) {
			;
		});
		return filtered;
	};
}]);